import * as cvss from 'cvss';

export interface CvssMetrics {
  AV?: 'N' | 'A' | 'L' | 'P';
  AC?: 'L' | 'H';
  PR?: 'N' | 'L' | 'H';
  UI?: 'N' | 'R';
  S?: 'U' | 'C';
  C?: 'N' | 'L' | 'H';
  I?: 'N' | 'L' | 'H';
  A?: 'N' | 'L' | 'H';
}

export function generateCvssVector(metrics: CvssMetrics): string {
  if (!metrics.AV || !metrics.AC || !metrics.PR || !metrics.UI || !metrics.S || !metrics.C || !metrics.I || !metrics.A) {
    return '';
  }
  return `CVSS:3.1/AV:${metrics.AV}/AC:${metrics.AC}/PR:${metrics.PR}/UI:${metrics.UI}/S:${metrics.S}/C:${metrics.C}/I:${metrics.I}/A:${metrics.A}`;
}

export function calculateCvssScore(metrics: CvssMetrics | string | null): number | null {
  if (!metrics) return null;
  
  let vector = '';
  if (typeof metrics === 'string') {
    if (metrics.startsWith('CVSS:')) {
      vector = metrics;
    } else {
      try {
        const parsed = JSON.parse(metrics);
        vector = generateCvssVector(parsed);
      } catch (e) {
        return null;
      }
    }
  } else {
    vector = generateCvssVector(metrics);
  }

  if (!vector) return null;

  try {
    // The 'cvss' npm module doesn't natively recognize CVSS:3.1 prefix
    // Since 3.0 and 3.1 base score formulas are identical, we swap the prefix
    const score: any = cvss.getScore(vector.replace('CVSS:3.1', 'CVSS:3.0'));
    return typeof score === 'number' ? score : (score?.base ?? null);
  } catch (err) {
    console.error('Error calculating CVSS:', err);
    return null;
  }
}
